import { Product } from '../types';
import { getProductImageUrl } from './imageUtils';

// Utility function to normalize product data from API
export const normalizeProduct = (product: any): Product => {
    return {
        ...product,
        // Map backend field names to more intuitive names
        name: product.designation || product.name,
        price: product.unit_price || product.price,
        kosher_certification: product.cacherout || product.kosher_certification,
        // Use S3 image URL if reference number exists, fallback to existing image_url
        image_url: product.code ? getProductImageUrl(product.code) : (product.photo_url || product.image_url),
    };
};

// Utility function to format price
export const formatPrice = (price: number): string => {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
    }).format(price);
};

// Utility function to format file size
export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// Utility function to truncate text
export const truncateText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
};
